module.exports = __webpack_public_path__ + "img/chevron-right.16a03d0e.svg";